/* eslint-disable id-length */
import { mixpanel, traffic2 } from '../../utils/buildAnalyticsEvents';

export const SUGGESTED_ITEMS_EVENTS = {
  SUGGESTED_ITEMS_FIRST_EMAIL_KICKOFF: {
    ...mixpanel('GUM Suggested Items First Email Kickoff Click'),
    ...traffic2('marketing.suggested_items_first_email_kickoff.click')
  },
  SUGGESTED_ITEMS_HOP_BACK_INTO_EMAIL_MARKETING: {
    ...mixpanel('GUM Suggested Items Hop Back Into Email Marketing Click'),
    ...traffic2('marketing.suggested_items_hop_back_into_email_marketing.click')
  },
  SUGGESTED_ITEMS_CAMPAIGN_SEGMENTATION: {
    ...mixpanel('GUM Suggested Items Campaign Segmentation Click'),
    ...traffic2('marketing.suggested_items_campaign_segmentation.click')
  },
  SUGGESTED_ITEMS_CHECKOUT_LATEST_FEATURES: {
    ...mixpanel('GUM Suggested Items Checkout Latest Features Click'),
    ...traffic2('marketing.suggested_items_checkout_latest_features.click')
  },
  SUGGESTED_ITEMS_CHECKOUT_NEW_FEATURES: {
    ...mixpanel('GUM Suggested Items Checkout New Features Click'),
    ...traffic2('marketing.suggested_items_checkout_new_features.click')
  },
  SUGGESTED_ITEMS_LAUNCH_AN_EMAIL_CAMPAIGN: {
    ...mixpanel('GUM Suggested Items Launch An Email Campaign Click'),
    ...traffic2('marketing.suggested_items_launch_an_email_campaign.click')
  },
  SUGGESTED_ITEMS_REENGAGE_YOUR_AUDIENCE: {
    ...mixpanel('GUM Suggested Items Reengage Your Audience Click'),
    ...traffic2('marketing.suggested_items_reengage_your_audience.click')
  },
  SUGGESTED_ITEMS_SEE_UPCOMING_FEATURES: {
    ...mixpanel('GUM Suggested Items First To See Upcoming Features Click'),
    ...traffic2('marketing.suggested_items_see_upcoming_features.click')
  },
  SUGGESTED_ITEMS_SEND_TEST_EMAIL: {
    ...mixpanel('GUM Suggested Items Send Test Email Click'),
    ...traffic2('marketing.suggested_items_send_test_email.click')
  },
  SUGGESTED_ITEMS_SETUP_AUTOMATIONS: {
    ...mixpanel('GUM Suggested Items Setup Automations Click'),
    ...traffic2('marketing.suggested_items_setup_automations.click')
  },
  SUGGESTED_ITEMS_SETUP_CONTACTS: {
    ...mixpanel('GUM Suggested Items Setup Contacts Click'),
    ...traffic2('marketing.suggested_items_setup_contacts.click')
  },
  SUGGESTED_ITEMS_SETUP_CONTACTS_IN_LISTS: {
    ...mixpanel('GUM Suggested Items Setup Contacts in Lists Click'),
    ...traffic2('marketing.suggested_items_setup_contacts_in_lists.click')
  },
  SUGGESTED_ITEMS_VIEW_CAMPAIGN_STATS: {
    ...mixpanel('GUM Suggested Items View Campaign Stats Click'),
    ...traffic2('marketing.suggested_items_view_campaign_stats.click')
  },
  SUGGESTED_ITEMS_SEND_FEEDBACK: {
    ...mixpanel('GUM Suggested Items Send Us Feedback Suggestion Item Click'),
    ...traffic2('marketing.suggested_items_send_us_feedback.button.click')
  },
  SUGGESTED_ITEMS_CAMPAIGN_SEGMENTATION_DISMISS: {
    ...mixpanel('GUM Suggested Items Optimize Campaign Dismiss Click'),
    ...traffic2('marketing.suggested_items_optimize_campaign_dismiss.button.click')
  },
  SUGGESTED_ITEMS_SEND_FEEDBACK_DISMISS: {
    ...mixpanel('GUM Suggested Items Send Us Feedback Dismiss Click'),
    ...traffic2('marketing.suggested_items_send_us_feedback_dismiss.button.click')
  },
  SUGGESTED_ITEMS_CHECKOUT_LATEST_FEATURES_DISMISS: {
    ...mixpanel('GUM Suggested Items Checkout Latest Features And Updates Dismiss Click'),
    ...traffic2(
      'marketing.suggested_items_checkout_latest_features_and_updates_dismiss.button.click'
    )
  },
  SUGGESTED_ITEMS_SEE_UPCOMING_FEATURES_DISMISS: {
    ...mixpanel(
      'GUM Suggested Items Be The First To See Upcoming Features Suggestion Item Dismiss Click'
    ),
    ...traffic2('marketing.suggested_items_first_to_see_upcoming_features_dismiss.button.click')
  },
  SUGGESTED_ITEMS_REENGAGE_YOUR_AUDIENCE_DISMISS: {
    ...mixpanel('GUM Suggested Items Reengage with Audience Dismiss Click'),
    ...traffic2('marketing.suggested_items_set_up_contact_dismiss.button.click')
  },
  SUGGESTED_ITEMS_VIEW_CAMPAIGN_STATS_DISMISS: {
    ...mixpanel('GUM Suggested Items View Campaign Analytics And Insights Dismiss Click'),
    ...traffic2(
      'marketing.suggested_items_view_campaign_analytics_and_Insights_dismiss.button.click'
    )
  },
  SUGGESTED_ITEMS_CHECKOUT_NEW_FEATURES_DISMISS: {
    ...mixpanel('GUM Suggested Items Checkout New Features In Email Composer Dismiss Click'),
    ...traffic2(
      'marketing.suggested_items_checkout_new_features_in_email_composer_dismiss_suggestion_item.button.click'
    )
  },
  SUGGESTED_ITEMS_DISMISS_SUGGESTION_MODAL_CONFIRM: {
    ...mixpanel('GUM Suggested Items Dismiss Suggestion Modal Confirm Click'),
    ...traffic2('marketing.suggested_items_dismiss_suggestion_modal_confirm.button.click')
  },
  SUGGESTED_ITEMS_DISMISS_SUGGESTION_MODAL_CANCEL: {
    ...mixpanel('GUM Suggested Items Dismiss Suggestion Modal Cancel Click'),
    ...traffic2('marketing.suggested_items_dismiss_suggestion_modal_cancel.button.click')
  }
};
